import React from 'react';
import { Alert } from '@mui/material';

export default function NoMatchingRecords({ sx }) {
  return (
    <Alert severity="info" sx={sx}>
      No matching records found.
    </Alert>
  );
}
